import classNames from "classnames";
import * as React from "react";
import FieldWrapper, {Props as FieldWrapperProps} from "./FieldWrapper";

export type FormFieldWrapperProps = {
  containerClassName?: string,
  labelClassName?: string,
  label?: React.ReactNode,
  labelStyle?: FieldWrapperProps['labelStyle'],
  error?: string,
  errorAbsolute?: boolean,
  className?: string,
  withoutWrapper?: boolean,
}

// export type FormFieldWrapperProps = React.ComponentProps<typeof FieldWrapper> & {
//   containerClassName?: string,
//   withoutWrapper?: boolean,
// };

type FormFieldOptions = {
  containerTag?: 'div' | 'label',
  containerClassName?: string,
}

function hocFieldWrapper<T extends React.ComponentType, P extends object>(
  Component: React.ComponentType<P>,
  options?: FormFieldOptions
) {
  type ComponentType = typeof Component;
  type Props = P & FormFieldWrapperProps

  //todo пофиксить
  //@ts-ignore
  const FormFieldWrapper: React.ForwardRefExoticComponent<Props> = React.forwardRef<ComponentType, Props>((props, ref) => {
    const {
      containerClassName,
      labelClassName,
      label,
      labelStyle,
      error,
      errorAbsolute,
      withoutWrapper,
      ...remainingProps
    } = props;

    const C = <Component ref={ref} {...remainingProps as P} invalid={!!error} />;
    if (withoutWrapper) return C;
    return (
      <FieldWrapper
        className={classNames(containerClassName, options?.containerClassName)}
        containerTag={options?.containerTag}
        labelClassName={labelClassName}
        label={label}
        labelStyle={labelStyle}
        error={error}
        errorAbsolute={errorAbsolute}
      >
        {C}
      </FieldWrapper>
    );
  });
  FormFieldWrapper.displayName = `FieldWrapper(${Component.displayName || Component.name})`;

  return FormFieldWrapper;
}

export default hocFieldWrapper;
